export default "<figure>\r\n\r\n\t<img src=\"assets/images/tankundrast_logo.png\">\r\n\r\n</figure>\r\n"